import React, { useState, useEffect, useRef } from 'react';
import styles from './visitFormComment.module.scss';
import FormField from '../../component/formField/FormField';
// import backBtn from '../../static/icon/backBtn.svg';
import backBtn from '../../static/icon/back_button.png';
import FileIcon from '../../static/images/file_icon.png';
import IconNode from '../../static/images/icon_node.png';
import IconFile from '../../static/images/icon_file.png';
import { withRouter } from 'react-router-dom';


function VisitForm(props: any) {
    //区分是否是展示在之前的页面
    const [inPrePage, setInPrePage] = useState<boolean>(props.inPrePage);

    //表单组件
    const formRef = useRef<any>(null);

    const [visitForms, setVisitForms] = useState<any>([]);

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;

    useEffect(() => {
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');

        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
    }, [])
    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {

        if (props.subjectData && props.subjectData.visits) {
            setVisitForms(props.subjectData.visits);
        }
    }, [])

    return (
        <div className={`${styles.visitForm_content} ${inPrePage ? styles.pre_page_content : ''}`}>
            <div className={styles.node_content_wrap}>
            {
                visitForms && visitForms.map((item: any, itemIndex: any) => {
                    return (
                        <div className={styles.node_content}>
                            <div className={`${styles.node_icon} ${itemIndex === (visitForms.length - 1) ? styles.node_icon_last : ''}`}><img src={IconNode} alt="" /></div>
                            <div className={styles.node_info}>
                                <div className={styles.visit_title}>
                                    {item.name}
                                </div>
                                {
                                    item.forms && item.forms.map((formItem: any, itemFormIndex: any) => {

                                        return (
                                            <div>
                                                <div className={styles.visit_form_title}>
                                                    <img src={IconFile} alt="" />
                                                    {formItem.name}
                                                </div>
                                                <div className={styles.visit_form_content}>
                                                    <FormField
                                                        readonly={true}
                                                        formId={formItem.id} 
                                                        formCode={formItem.detail.formCode} 
                                                        version={formItem.detail.version} 
                                                        fieldList={formItem.detail} 
                                                        ref={formRef} 
                                                    ></FormField>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
            </div>
            {/* 操作按钮 */}
            <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                <img src={backBtn} alt="back" onClick={() => { props.history.go(-1) }} />
            </div>
        </div>
    )
}

export default withRouter(VisitForm);